/* eslint-disable */
window.tutuki = window.tutuki || {};

window.tutuki.cookieExists = function (cookieName) {
  return document.cookie
    .split(";")
    .some((item) => item.trim().startsWith(cookieName + "="));
};

window.tutuki.cookieValue = function (cookieName) {
  return document.cookie
    .split(";")
    .find((row) => row.trim().startsWith(cookieName + "="))
    .split("=")[1];
};

window.tutuki.getConsent = function () {
  if (
    tutuki.cookieExists("cookie_consent_user_accepted") &&
    tutuki.cookieExists("cookie_consent_level")
  ) {
    return {
      accepted: JSON.parse(tutuki.cookieValue("cookie_consent_user_accepted")),
      level: JSON.parse(tutuki.cookieValue("cookie_consent_level")),
    };
  }

  return {
    accepted: false,
    level: {
      functionality_storage: true,
      ad_storage: false,
      analytics_storage: false,
      personalization_storage: false,
      ad_user_data: false,
      ad_personalization: false,
      // "security_storage": true
    },
  };
};



// WEBPACK FOOTER //
// ./scripts/util/consent.js